import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistashotxImg from '@/assets/images/products/vistashotx.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaShotX = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Shot X"
        subTitle="High Performance Powder Accelerator For Dry Mix Shotcrete"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          title="Description"
          imageUrl={vistashotxImg}
          content="A ready to use alkali free accelerator in powder form for use with dry gunite mixes. It allows spraying to take place even on wet surfaces subject to slight infiltration."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Improved water tightness",
                "Reduced rebound",
                "Better adhesion to areas of slight seepage",
                "Chloride free and does not corrode the reinforcement",
              ],
              [
                "Improves overhead spraying",
                "Produces high strength concrete",
                "Speeds up the job",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Area of Application">
          <CustomLists
            items={[
              [
                "Tunnels and galleries",
                "Securing rock-faces",
                "Embarkment and excavations",
                "Thin-section concrete shells",
              ],
              [
                "Highly economical",
                "Concrete repair work",
                "Strengthening concrete structures",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                [
                  "Aspect",
                  "Setting time (Testing using Gillmore apparatus)",
                ],
                [
                  "White powder",
                  "Initial setting time within 3 Min. Final setting time within 12 Min.",
                ],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Precautions">
          <Paragraph content="Vista Shot - X is non-toxic and ingestion is to be avoided. If contact with eyes occurs, wash well immediately with water and seek medical advice." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaShotX;
